import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, useMediaQuery } from '@material-ui/core';

import {
    ContainerMui,
    ColorHex,
    BorderRadiusMui,
    ISelectOptions,
    Select,
    Spacer
} from '../../../../styles';
import { TexteAvecInfoBulle } from '../../../../components';

export interface IFrequenceSelectProps {
    options: ISelectOptions;
    value: string;
    onChange: (value: string) => void;
    onToolTipClick: () => void;
}

export const FrequenceSelect: React.FC<IFrequenceSelectProps> = ({
    options,
    value,
    onChange,
    onToolTipClick
}) => {
    // Hooks
    const [t] = useTranslation('FrequenceSelect');
    const isMobile = useMediaQuery('(max-width:640px)');

    return (
        <ContainerMui
            borderRadius={BorderRadiusMui.sm}
            border={2}
            borderColor={ColorHex.graphite}
            maxWidth={isMobile ? '100%' : '71%'}
            padding="1rem"
            spacerDistance={6}
        >
            <TexteAvecInfoBulle
                label={t('frequence')}
                labelInfoBulle={t('tooltip')}
                labelHorsEcranInfoBulle={t('frequence')}
                labelColor={ColorHex.lightGraphite5}
                iconColorCustom={ColorHex.lightGraphite5}
                onToolTipActive={onToolTipClick}
            />
            <Spacer all={2} />
            <Box
                display="block"
                flexDirection="row"
                width={isMobile ? '100%' : '15.5rem'}
            >
                <Select
                    dataTestId={'liste_frequence'}
                    identifier={'liste_frequence'}
                    hasNoDefaultOption
                    value={value}
                    fullWidth
                    options={options}
                    onChange={(value) => onChange(value)}
                />
            </Box>
        </ContainerMui>
    );
};
